export default function GetLocalStorage(params) {
    const data = JSON.parse(localStorage.getItem(params || "user_profile"));
    return data;
  }